import SectionInfo from './SectionInfo';

export default SectionInfo;
